export default "__VITE_ASSET__DXWczj9w__"